module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor07-69df3007c0bf086aa4e45ea087174b4f.jpg";